import formatFilterForQuery from './formatFilterForQuery';

export default function formatFiltersForQuery(activeFilters) {
  return activeFilters.reduce(
    (filterQueryParams, filtersForField, fieldId) => (
      { ...filterQueryParams, ...formatFilterForQuery(fieldId, filtersForField) }
    ), {});
}




// WEBPACK FOOTER //
// ./app/helpers/facets/formatFiltersForQuery.js